
export type SearchUsersParams = {
/**
 * 검색어 (사용자명, 이메일 등)
 */
query: string;
page?: number;
size?: number;
};
